import React, { useState } from 'react';
import { Card, Table, Input, Select, Button, Badge, Tag } from 'antd';
import { 
  SearchOutlined, 
  PlusOutlined,
  MessageOutlined,
  MailOutlined,
  FacebookOutlined,
  GoogleOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './Campaigns.css';

const { Option } = Select;

const Campaigns = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  // Mock campaign data
  const smsCampaigns = [
    { id: 1, name: 'Winter HVAC Tune-Up Reminder', location: 'Nashville HQ', status: 'active', sent: 4250, delivered: 4080, deliveryRate: '96.0%', clicks: 171, ctr: '4.2%', routeMiles: '845 mi', imprMile: 87 },
    { id: 2, name: 'Holiday Service Special', location: 'Nashville HQ', status: 'active', sent: 3180, delivered: 3053, deliveryRate: '96.0%', clicks: 134, ctr: '4.4%', routeMiles: '820 mi', imprMile: 88 },
    { id: 3, name: 'New Year Maintenance Alert', location: 'Nashville HQ', status: 'draft', sent: 0, delivered: 0, deliveryRate: '—', clicks: 0, ctr: '—', routeMiles: '—', imprMile: '—' },
    { id: 4, name: 'Cool Springs Service Alert', location: 'Franklin', status: 'active', sent: 2850, delivered: 2736, deliveryRate: '96.0%', clicks: 104, ctr: '3.8%', routeMiles: '520 mi', imprMile: 85 },
    { id: 5, name: 'December Loyalty Check-In', location: 'Franklin', status: 'active', sent: 1920, delivered: 1843, deliveryRate: '96.0%', clicks: 70, ctr: '3.8%', routeMiles: '380 mi', imprMile: 85 },
    { id: 6, name: 'Rutherford County Special', location: 'Murfreesboro', status: 'active', sent: 2400, delivered: 2304, deliveryRate: '96.0%', clicks: 104, ctr: '4.5%', routeMiles: '440 mi', imprMile: 83 },
    { id: 7, name: 'Winter Prep Reminder', location: 'Murfreesboro', status: 'active', sent: 1680, delivered: 1613, deliveryRate: '96.0%', clicks: 73, ctr: '4.5%', routeMiles: '320 mi', imprMile: 83 },
    { id: 8, name: 'Fort Campbell Area Promo', location: 'Clarksville', status: 'active', sent: 2200, delivered: 2112, deliveryRate: '96.0%', clicks: 82, ctr: '3.9%', routeMiles: '420 mi', imprMile: 85 },
    { id: 9, name: 'Lakeside Service Special', location: 'Hendersonville', status: 'active', sent: 1650, delivered: 1584, deliveryRate: '96.0%', clicks: 76, ctr: '4.8%', routeMiles: '320 mi', imprMile: 90 },
    { id: 10, name: 'Memphis Metro Alert', location: 'Memphis', status: 'active', sent: 3850, delivered: 3696, deliveryRate: '96.0%', clicks: 133, ctr: '3.6%', routeMiles: '680 mi', imprMile: 87 },
    { id: 11, name: 'Beale Street Winter Promo', location: 'Memphis', status: 'active', sent: 2750, delivered: 2640, deliveryRate: '96.0%', clicks: 95, ctr: '3.6%', routeMiles: '520 mi', imprMile: 87 },
    { id: 12, name: 'Atlanta Metro Winter Push', location: 'Atlanta Metro', status: 'active', sent: 5600, delivered: 5558, deliveryRate: '96.0%', clicks: 228, ctr: '4.1%', routeMiles: '950 mi', imprMile: 90 },
    { id: 13, name: 'Peachtree Corridor Special', location: 'Atlanta Metro', status: 'active', sent: 4200, delivered: 4032, deliveryRate: '96.0%', clicks: 165, ctr: '4.1%', routeMiles: '720 mi', imprMile: 90 },
    { id: 14, name: 'Holiday HVAC Check', location: 'Atlanta Metro', status: 'draft', sent: 0, delivered: 0, deliveryRate: '—', clicks: 0, ctr: '—', routeMiles: '—', imprMile: '—' },
    { id: 15, name: 'Cobb County Service Alert', location: 'Marietta', status: 'active', sent: 2100, delivered: 2016, deliveryRate: '96.0%', clicks: 71, ctr: '3.5%', routeMiles: '420 mi', imprMile: 82 }
  ];

  const emailCampaigns = [
    { id: 1, name: 'December Newsletter', location: 'Nashville HQ', status: 'active', sent: 8500, opens: 2060, openRate: '25.0%', clicks: 120, ctr: '5.8%', totalMiles: '720 mi', imprMile: 88 },
    { id: 2, name: 'End of Year Service Recap', location: 'Nashville HQ', status: 'active', sent: 5200, opens: 1287, openRate: '25.5%', clicks: 74, ctr: '5.7%', totalMiles: '455 mi', imprMile: 88 },
    { id: 3, name: 'Franklin Monthly Update', location: 'Franklin', status: 'active', sent: 4800, opens: 1117, openRate: '24.0%', clicks: 58, ctr: '5.2%', totalMiles: '420 mi', imprMile: 85 },
    { id: 4, name: 'Holiday Promo - Williamson County', location: 'Franklin', status: 'completed', sent: 3200, opens: 745, openRate: '24.0%', clicks: 39, ctr: '5.2%', totalMiles: '360 mi', imprMile: 85 },
    { id: 5, name: 'Murfreesboro Service Update', location: 'Murfreesboro', status: 'active', sent: 3600, opens: 864, openRate: '25.0%', clicks: 52, ctr: '6.0%', totalMiles: '380 mi', imprMile: 83 },
    { id: 6, name: 'Clarksville Winter Tips', location: 'Clarksville', status: 'active', sent: 2900, opens: 696, openRate: '25.0%', clicks: 43, ctr: '6.2%', totalMiles: '340 mi', imprMile: 85 },
    { id: 7, name: 'Hendersonville Promo', location: 'Hendersonville', status: 'active', sent: 2400, opens: 576, openRate: '25.0%', clicks: 35, ctr: '6.1%', totalMiles: '290 mi', imprMile: 90 },
    { id: 8, name: 'Memphis Service Newsletter', location: 'Memphis', status: 'active', sent: 6800, opens: 1632, openRate: '25.0%', clicks: 98, ctr: '6.0%', totalMiles: '580 mi', imprMile: 87 },
    { id: 9, name: 'Atlanta Metro Newsletter', location: 'Atlanta Metro', status: 'active', sent: 9200, opens: 2208, openRate: '25.0%', clicks: 132, ctr: '6.0%', totalMiles: '820 mi', imprMile: 90 },
    { id: 10, name: 'Marietta Monthly', location: 'Marietta', status: 'active', sent: 3400, opens: 816, openRate: '25.0%', clicks: 49, ctr: '6.0%', totalMiles: '380 mi', imprMile: 82 }
  ];

  const metaCampaigns = [
    { id: 1, name: 'Nashville Holiday Awareness', location: 'Nashville HQ', status: 'active', budget: '$2,500', spent: '$1,847', impressions: '145,000', clicks: '3,480', ctr: '2.4%', cpc: '$0.53', conversions: 87, routeMiles: '680 mi', imprMile: 88 },
    { id: 2, name: 'Retargeting - Past Customers TN', location: 'Nashville HQ', status: 'active', budget: '$1,800', spent: '$1,245', impressions: '98,000', clicks: '2,352', ctr: '2.4%', cpc: '$0.53', conversions: 58, routeMiles: '520 mi', imprMile: 88 },
    { id: 3, name: 'Franklin Brand Awareness', location: 'Franklin', status: 'active', budget: '$1,500', spent: '$1,089', impressions: '82,000', clicks: '1,722', ctr: '2.1%', cpc: '$0.63', conversions: 43, routeMiles: '480 mi', imprMile: 85 },
    { id: 4, name: 'Murfreesboro Local Traffic', location: 'Murfreesboro', status: 'active', budget: '$1,000', spent: '$724', impressions: '54,000', clicks: '1,242', ctr: '2.3%', cpc: '$0.58', conversions: 31, routeMiles: '280 mi', imprMile: 83 },
    { id: 5, name: 'Clarksville Awareness Q4', location: 'Clarksville', status: 'active', budget: '$900', spent: '$652', impressions: '48,000', clicks: '912', ctr: '1.9%', cpc: '$0.71', conversions: 23, routeMiles: '320 mi', imprMile: 85 },
    { id: 6, name: 'Indian Lake Brand Campaign', location: 'Hendersonville', status: 'active', budget: '$800', spent: '$579', impressions: '42,000', clicks: '1,092', ctr: '2.6%', cpc: '$0.53', conversions: 27, routeMiles: '380 mi', imprMile: 90 },
    { id: 7, name: 'Memphis Brand Awareness', location: 'Memphis', status: 'active', budget: '$1,800', spent: '$1,305', impressions: '98,000', clicks: '1,960', ctr: '2.0%', cpc: '$0.67', conversions: 49, routeMiles: '540 mi', imprMile: 87 },
    { id: 8, name: 'Memphis Retargeting Q4', location: 'Memphis', status: 'active', budget: '$1,200', spent: '$867', impressions: '65,000', clicks: '1,300', ctr: '2.0%', cpc: '$0.67', conversions: 32, routeMiles: '380 mi', imprMile: 87 },
    { id: 9, name: 'Atlanta Local Services - Q4', location: 'Atlanta Metro', status: 'active', budget: '$3,000', spent: '$2,178', impressions: '165,000', clicks: '4,125', ctr: '2.5%', cpc: '$0.53', conversions: 103, routeMiles: '780 mi', imprMile: 90 },
    { id: 10, name: 'Buckhead Targeting Campaign', location: 'Atlanta Metro', status: 'active', budget: '$2,000', spent: '$1,452', impressions: '110,000', clicks: '2,750', ctr: '2.5%', cpc: '$0.53', conversions: 69, routeMiles: '540 mi', imprMile: 90 },
    { id: 11, name: 'Marietta Brand Awareness', location: 'Marietta', status: 'active', budget: '$900', spent: '$652', impressions: '48,000', clicks: '864', ctr: '1.8%', cpc: '$0.75', conversions: 22, routeMiles: '340 mi', imprMile: 82 }
  ];

  const googleCampaigns = [
    { id: 1, name: 'Local Services Search - Nashville', location: 'Nashville HQ', type: 'Search', status: 'active', budget: '$2,000', spent: '$1,456', impressions: '42,000', clicks: '1,638', ctr: '3.9%', cpc: '$0.89', conversions: 98, routeMiles: '560 mi', imprMile: 88 },
    { id: 2, name: 'Display Remarketing - TN Markets', location: 'Nashville HQ', type: 'Display', status: 'paused', budget: '$1,200', spent: '$1,200', impressions: '185,000', clicks: '2,775', ctr: '1.5%', cpc: '$0.43', conversions: 42, routeMiles: '420 mi', imprMile: 88 },
    { id: 3, name: 'Local Search - Franklin TN', location: 'Franklin', type: 'Search', status: 'active', budget: '$1,200', spent: '$876', impressions: '28,000', clicks: '980', ctr: '3.5%', cpc: '$0.89', conversions: 52, routeMiles: '340 mi', imprMile: 85 },
    { id: 4, name: 'Murfreesboro Search Ads', location: 'Murfreesboro', type: 'Search', status: 'active', budget: '$800', spent: '$654', impressions: '18,500', clicks: '759', ctr: '4.1%', cpc: '$0.86', conversions: 38, routeMiles: '260 mi', imprMile: 83 },
    { id: 5, name: 'Clarksville Local Search', location: 'Clarksville', type: 'Search', status: 'active', budget: '$800', spent: '$582', impressions: '19,500', clicks: '624', ctr: '3.2%', cpc: '$0.93', conversions: 31, routeMiles: '260 mi', imprMile: 85 },
    { id: 6, name: 'Memphis Local Search', location: 'Memphis', type: 'Search', status: 'active', budget: '$1,500', spent: '$1,092', impressions: '35,000', clicks: '1,190', ctr: '3.4%', cpc: '$0.92', conversions: 60, routeMiles: '480 mi', imprMile: 87 },
    { id: 7, name: 'Atlanta Search - Home Services', location: 'Atlanta Metro', type: 'Search', status: 'active', budget: '$2,500', spent: '$1,820', impressions: '48,000', clicks: '2,016', ctr: '4.2%', cpc: '$0.90', conversions: 121, routeMiles: '720 mi', imprMile: 90 },
    { id: 8, name: 'Performance Max - Georgia', location: 'Atlanta Metro', type: 'PMax', status: 'active', budget: '$2,000', spent: '$1,456', impressions: '125,000', clicks: '3,750', ctr: '3.0%', cpc: '$0.39', conversions: 94, routeMiles: '580 mi', imprMile: 90 },
    { id: 9, name: 'Marietta Local Search', location: 'Marietta', type: 'Search', status: 'active', budget: '$800', spent: '$582', impressions: '21,000', clicks: '651', ctr: '3.1%', cpc: '$0.89', conversions: 33, routeMiles: '320 mi', imprMile: 82 }
  ];

  const smsColumns = [
    { title: 'Campaign Name', dataIndex: 'name', key: 'name', width: 250, fixed: 'left' },
    { title: 'Location', dataIndex: 'location', key: 'location', width: 150 },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 100, render: (status) => (
      <Badge status={status === 'active' ? 'success' : status === 'draft' ? 'default' : 'processing'} text={status.charAt(0).toUpperCase() + status.slice(1)} />
    )},
    { title: 'Sent', dataIndex: 'sent', key: 'sent', width: 100, align: 'right' },
    { title: 'Delivered', dataIndex: 'delivered', key: 'delivered', width: 100, align: 'right' },
    { title: 'Delivery Rate', dataIndex: 'deliveryRate', key: 'deliveryRate', width: 120, align: 'right' },
    { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', width: 100, align: 'right' },
    { title: 'CTR', dataIndex: 'ctr', key: 'ctr', width: 100, align: 'right' },
    { title: 'Route Miles', dataIndex: 'routeMiles', key: 'routeMiles', width: 120, align: 'right' },
    { title: 'Impr/Mile', dataIndex: 'imprMile', key: 'imprMile', width: 100, align: 'right' }
  ];

  const emailColumns = [
    { title: 'Campaign Name', dataIndex: 'name', key: 'name', width: 250, fixed: 'left' },
    { title: 'Location', dataIndex: 'location', key: 'location', width: 150 },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 100, render: (status) => (
      <Badge status={status === 'active' ? 'success' : status === 'completed' ? 'default' : 'processing'} text={status.charAt(0).toUpperCase() + status.slice(1)} />
    )},
    { title: 'Sent', dataIndex: 'sent', key: 'sent', width: 100, align: 'right' },
    { title: 'Opens', dataIndex: 'opens', key: 'opens', width: 100, align: 'right' },
    { title: 'Open Rate', dataIndex: 'openRate', key: 'openRate', width: 120, align: 'right' },
    { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', width: 100, align: 'right' },
    { title: 'CTR', dataIndex: 'ctr', key: 'ctr', width: 100, align: 'right' },
    { title: 'Total Miles', dataIndex: 'totalMiles', key: 'totalMiles', width: 120, align: 'right' },
    { title: 'Impr/Mile', dataIndex: 'imprMile', key: 'imprMile', width: 100, align: 'right' }
  ];

  const metaColumns = [
    { title: 'Campaign Name', dataIndex: 'name', key: 'name', width: 250, fixed: 'left' },
    { title: 'Location', dataIndex: 'location', key: 'location', width: 150 },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 100, render: (status) => (
      <Badge status={status === 'active' ? 'success' : 'default'} text={status.charAt(0).toUpperCase() + status.slice(1)} />
    )},
    { title: 'Budget', dataIndex: 'budget', key: 'budget', width: 120, align: 'right' },
    { title: 'Spent', dataIndex: 'spent', key: 'spent', width: 120, align: 'right' },
    { title: 'Impressions', dataIndex: 'impressions', key: 'impressions', width: 120, align: 'right' },
    { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', width: 100, align: 'right' },
    { title: 'CTR', dataIndex: 'ctr', key: 'ctr', width: 100, align: 'right' },
    { title: 'CPC', dataIndex: 'cpc', key: 'cpc', width: 100, align: 'right' },
    { title: 'Conversions', dataIndex: 'conversions', key: 'conversions', width: 120, align: 'right' },
    { title: 'Route Miles', dataIndex: 'routeMiles', key: 'routeMiles', width: 120, align: 'right' },
    { title: 'Impr/Mile', dataIndex: 'imprMile', key: 'imprMile', width: 100, align: 'right' }
  ];

  const googleColumns = [
    { title: 'Campaign Name', dataIndex: 'name', key: 'name', width: 250, fixed: 'left' },
    { title: 'Location', dataIndex: 'location', key: 'location', width: 150 },
    { title: 'Type', dataIndex: 'type', key: 'type', width: 100, render: (type) => (
      <Tag color={type === 'Search' ? 'blue' : type === 'Display' ? 'orange' : 'purple'}>{type}</Tag>
    )},
    { title: 'Status', dataIndex: 'status', key: 'status', width: 100, render: (status) => (
      <Badge status={status === 'active' ? 'success' : 'warning'} text={status.charAt(0).toUpperCase() + status.slice(1)} />
    )},
    { title: 'Budget', dataIndex: 'budget', key: 'budget', width: 120, align: 'right' },
    { title: 'Spent', dataIndex: 'spent', key: 'spent', width: 120, align: 'right' },
    { title: 'Impressions', dataIndex: 'impressions', key: 'impressions', width: 120, align: 'right' },
    { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', width: 100, align: 'right' },
    { title: 'CTR', dataIndex: 'ctr', key: 'ctr', width: 100, align: 'right' },
    { title: 'CPC', dataIndex: 'cpc', key: 'cpc', width: 100, align: 'right' },
    { title: 'Conversions', dataIndex: 'conversions', key: 'conversions', width: 120, align: 'right' },
    { title: 'Route Miles', dataIndex: 'routeMiles', key: 'routeMiles', width: 120, align: 'right' },
    { title: 'Impr/Mile', dataIndex: 'imprMile', key: 'imprMile', width: 100, align: 'right' }
  ];

  return (
    <div className="campaign-management-page">
      {/* Header */}
      <div className="campaign-header">
        <div>
          <h1 className="page-title">Campaign Management</h1>
          <p className="page-subtitle">Manage all your advertising campaigns across platforms</p>
        </div>
        <div className="last-updated">Last updated: 5:51:41 PM</div>
      </div>

      {/* Title Bar */}
      <div className="campaign-title-bar">
        <div>
          <h2 className="section-title">Campaign Management</h2>
          <p className="section-subtitle">Create and manage targeted advertising campaigns</p>
        </div>
        <Button 
          type="primary" 
          icon={<PlusOutlined />} 
          size="large"
          onClick={() => navigate('/agency/new-campaign')}
        >
          Create Campaign
        </Button>
      </div>

      {/* Search and Filters */}
      <div className="campaign-filters">
        <Input
          placeholder="Search campaigns or locations..."
          prefix={<SearchOutlined />}
          size="large"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: 400 }}
        />
        <Select
          value={statusFilter}
          onChange={setStatusFilter}
          size="large"
          style={{ width: 200 }}
        >
          <Option value="all">All Statuses</Option>
          <Option value="active">Active</Option>
          <Option value="paused">Paused</Option>
          <Option value="draft">Draft</Option>
          <Option value="completed">Completed</Option>
        </Select>
      </div>

      {/* SMS Campaigns */}
      <div className="campaign-section">
        <div className="campaign-section-header">
          <div className="section-icon sms-icon">
            <MessageOutlined />
          </div>
          <div>
            <h3 className="section-title">SMS Campaigns</h3>
            <p className="campaign-count">{smsCampaigns.length} campaigns</p>
          </div>
        </div>
        <Card className="campaign-table-card">
          <Table
            columns={smsColumns}
            dataSource={smsCampaigns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            scroll={{ x: 1400 }}
          />
        </Card>
      </div>

      {/* Email Campaigns */}
      <div className="campaign-section">
        <div className="campaign-section-header">
          <div className="section-icon email-icon">
            <MailOutlined />
          </div>
          <div>
            <h3 className="section-title">Email Campaigns</h3>
            <p className="campaign-count">{emailCampaigns.length} campaigns</p>
          </div>
        </div>
        <Card className="campaign-table-card">
          <Table
            columns={emailColumns}
            dataSource={emailCampaigns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            scroll={{ x: 1400 }}
          />
        </Card>
      </div>

      {/* Meta Campaigns */}
      <div className="campaign-section">
        <div className="campaign-section-header">
          <div className="section-icon meta-icon">
            <FacebookOutlined />
          </div>
          <div>
            <h3 className="section-title">Meta Campaigns</h3>
            <p className="campaign-count">{metaCampaigns.length} campaigns</p>
          </div>
        </div>
        <Card className="campaign-table-card">
          <Table
            columns={metaColumns}
            dataSource={metaCampaigns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            scroll={{ x: 1600 }}
          />
        </Card>
      </div>

      {/* Google Campaigns */}
      <div className="campaign-section">
        <div className="campaign-section-header">
          <div className="section-icon google-icon">
            <GoogleOutlined />
          </div>
          <div>
            <h3 className="section-title">Google Campaigns</h3>
            <p className="campaign-count">{googleCampaigns.length} campaigns</p>
          </div>
        </div>
        <Card className="campaign-table-card">
          <Table
            columns={googleColumns}
            dataSource={googleCampaigns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            scroll={{ x: 1600 }}
          />
        </Card>
      </div>
    </div>
  );
};

export default Campaigns;
